/** This is a placeholder, not real render in dom */
var OptGroup = function OptGroup() {
  return null;
};

OptGroup.isSelectOptGroup = true;
export default OptGroup;


//////////////////
// WEBPACK FOOTER
// ../node_modules/rc-select/es/OptGroup.js
// module id = 528
// module chunks = 0